import store from 'store'

const el = '[data-content=StafetMailEditorOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetMailEditorOverlayDOM)=>{
            const type = StafetMailEditorOverlayDOM.dataset.type
            const data = {
                labels: JSON.parse(StafetMailEditorOverlayDOM.dataset.labels),
                isReadonly: StafetMailEditorOverlayDOM.dataset.isReadonly === 'true',
                stafetkode: StafetMailEditorOverlayDOM.dataset.stafetkode,
                holdkode: StafetMailEditorOverlayDOM.dataset.holdkode,
                senderEmail: StafetMailEditorOverlayDOM.dataset.senderEmail,
                allowSelectParticipants: StafetMailEditorOverlayDOM.dataset.allowSelectParticipants === 'true',
                allowSelectSeason: StafetMailEditorOverlayDOM.dataset.allowSelectSeason === 'true',
                allowAttachments: StafetMailEditorOverlayDOM.dataset.allowAttachments === 'true',
            }
            store.commit('main/set_page_overlay_content_data', { [type]: data })
        })
    }
}